// Первый вопрос — не оценивается (всегда показывается первым)
export const INTRO_QUESTION = {
  text: 'Как идут дела? Оцените свою работу на посту модератора. Справляетесь ли с текущими задачами? Что получается хорошо, а что — нет? Нравится ли вам роль? Как складываются отношения в коллективе?',
  notScored: true
};

// 17 вопросов с ответами (оцениваются 0 / 0.5 / 1). Из них случайно выбираются 12.
export const SCORED_QUESTIONS = [
  {
    id: 1,
    text: 'Игрок во время тех.проблем на серверах пишет - #компенсация и из за этого в чате начинается спам. Какое наказание игроки получат?',
    answer: 'Удаление + тайм-аут в случае спама от игроков/тех.проблема маджестика'
  },
  {
    id: 2,
    text: 'Игрок пишет в чат - Ебанный маджестик, крашит постоянно, так заебался уже',
    answer: 'Бан, 1.1 Проекта'
  },
  {
    id: 3,
    text: 'Игрок пишет в чат - проходит набор в семью, кто желает в лс',
    answer: 'Не наказуемо'
  },
  {
    id: 4,
    text: 'Игрок в чате тегнул другого игрока более 5-ти раз подряд, что следует выдать?',
    answer: 'варн 1.2'
  },
  {
    id: 5,
    text: 'Игрок пишет в чат - Иди нахуй, ты просто не понимаешь банальных вещей, я в ахуе с тебя такого',
    answer: '1.6 Предупреждение'
  },
  {
    id: 6,
    text: 'Игрок тегает руководство с критический проблемой на сервере, нужно ли ему выдать наказание?',
    answer: 'Не выдаём наказание'
  },
  {
    id: 7,
    text: 'Игрок тегает роль администраторов 5 сервера и задаёт вопрос - вы брать репорты собираетесь?',
    answer: 'варн за общий тег роли'
  },
  {
    id: 8,
    text: 'Игрок пишет в чат - Ну так не тупите и новости смотрите, а не спамьте, что с серваками',
    answer: 'Не нарушение'
  },
  {
    id: 9,
    text: 'Игрок в чате оскорбляет других игроков, какое следует ему наказание',
    answer: '1.1 игроков(слушайте, чтобы сказал именно игроков, а не просто 1.1)'
  },
  {
    id: 10,
    text: 'Ты зашёл в войс и слышишь такую тему, в голосовом чате идёт массовый спам звуками из панели дискорда/Включают звуки или музыку через SoundPad, что ты будешь делать? - А если, после предупреждений игроки продолжают нарушать?',
    answer: 'Предупреждения по 2.6, в случае продолжения мут голосового чата у игрока или тайм-аут'
  },
  {
    id: 11,
    text: 'Игрок 1(один) задаёт вопрос в чате - "С какого лвла можно вступить во фракцию?", Игрок 2(два) отвечает - "я точно не помню, но вроде-бы с 3", есть ли здесь нарушения и как ты поступишь в данной ситуации?',
    answer: 'Не наказуемо, следует поправить игрока 2 и сказать точный ответ игроку который задаёт вопрос'
  },
  {
    id: 12,
    text: 'Игрок в течении одной минуты написал 6 одинаковых сообщений, какое наказание ему следует выдать?',
    answer: 'Тайм-аут на 24 час нарушение 1.3'
  },
  {
    id: 13,
    text: 'Ты заметил сообщение с нарушением в чате которое было отправленно более 3 часов назад, выдашь ли ты наказание игроку?',
    answer: 'Нет, просто удаление(максимальное время 2 часа, чтобы выдать наказание)'
  },
  {
    id: 14,
    text: 'В голосовом канале игроки разговаривают не на русском языке, при этом общество в котором происходит диалог, понимает друг друга, выдашь ли ты наказание игрокам, если да то какое?',
    answer: 'Не наказуемо'
  },
  {
    id: 15,
    text: 'Игрок отправляет сообщение в канал memes, которое никак не связанное с мемом и с Маджестиком в целом, какое наказание он получит и наказуемо ли подобное?',
    answer: 'Наказуемо, предупреждение - сообщение не по теме в memes'
  },
  {
    id: 16,
    text: 'В чат отправили ссылку на видео ютуб с названием "Выносим гетто | GTA5RP 3", наказуемо?',
    answer: 'Наказуемо, предупреждение - реклама'
  },
  {
    id: 17,
    text: 'Игрок отправляет в общий чат ссылку на хостинг с картинкой улыбающегося кота, нарушает ли он?',
    answer: 'Не нарушение'
  }
];

const TOTAL_SCORED = 12; // из 17 выбираем 12
const SCORES = [0, 0.5, 1];

/** Выбрать 12 случайных вопросов из 17 */
export function pickRandomScoredQuestions() {
  const shuffled = [...SCORED_QUESTIONS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, TOTAL_SCORED);
}

/** Интерпретация баллов: 0–5 не прошёл, 5.5–8 50/50, 8.5–12 прошёл отлично */
export function getResultLabel(totalScore) {
  if (totalScore <= 5) return { label: 'Не прошёл обзвон', status: 'fail' };
  if (totalScore < 8.5) return { label: '50/50', status: 'half' };
  return { label: 'Прошёл обзвон отлично', status: 'pass' };
}

/** Рекомендации для модератора по итогам обзвона */
export function getRecommendations(totalScore) {
  if (totalScore <= 5) {
    return [
      'Повторите с модератором правила проекта и разделы наказаний (1.1–1.6, 2.6 и т.д.).',
      'Рекомендуется провести дополнительное обучение по типовым ситуациям в чате и голосовых каналах.',
      'Выдайте модератору памятку с эталонными ответами на частые вопросы — пусть держит под рукой.',
      'Назначьте повторный обзвон через некоторое время после проработки материала.'
    ];
  }
  if (totalScore < 8.5) {
    return [
      'Разберите с модератором конкретные вопросы, где были потеряны баллы — закрепите правильные формулировки.',
      'Обратите внимание на различие «1.1 игроков» и «1.1 проекта», тайм-ауты и теги ролей.',
      'Рекомендуется чаще заходить в чат и сверять решения с правилами при сомнениях.',
      'Можно провести короткий повторный обзвон через 2–3 недели для закрепления.'
    ];
  }
  return [
    'Модератор хорошо ориентируется в правилах — поддерживайте текущий уровень практикой в чате.',
    'При желании можно периодически напоминать про обновления правил и прецеденты.',
    'Рекомендуется привлекать к разбору сложных кейсов для обмена опытом с другими Junior.'
  ];
}

export { SCORES };
